import { DZ_COLOR_GREEN_100, DZ_COLOR_GREEN_200, DZ_COLOR_ORANGE_200, DZ_COLOR_ORANGE_300 } from '@blk/daisy/core/styles';

export class DataServiceConstants {

	public static readonly HEAT_MAP_COLORS = {
		LOW: DZ_COLOR_GREEN_200,
		MEDIUM_LOW: DZ_COLOR_GREEN_100,
		MEDIUM_HIGH: DZ_COLOR_ORANGE_200,
		HIGH: DZ_COLOR_ORANGE_300
	};

	public static readonly HEAT_MAP_RANKS = [
		{ categoryId: 'returnY1', categoryRankId: 'returnY1CategoryRank' },
		{ categoryId: 'returnY3', categoryRankId: 'returnY3CategoryRank' },
		{ categoryId: 'returnY5', categoryRankId: 'returnY5CategoryRank' },
		{ categoryId: 'returnY10', categoryRankId: 'returnY10CategoryRank' }
	];

	public static readonly HEAT_MAP_THRESHOLDS = {
		MIN_THRESHOLD: 25,
		MID_THRESHOLD: 50,
		MAX_THRESHOLD: 75
	};

	public static readonly HEAT_MAP_THRESHOLDS_ARRAY = [
		DataServiceConstants.HEAT_MAP_THRESHOLDS.MIN_THRESHOLD,
		DataServiceConstants.HEAT_MAP_THRESHOLDS.MID_THRESHOLD,
		DataServiceConstants.HEAT_MAP_THRESHOLDS.MAX_THRESHOLD,
		100
	];


	public static readonly FI_OBSERVATIONS_RISK_BUCKET_LABELS = {
		SPREADS: 'Spreads',
		RATES: 'Rates',
		OTHER: 'Other'
	};

	public static readonly TAX_LOSS_HARVEST_THRESHOLD = -10;

	public static readonly DEFAULT_COLUMN_WIDTH = {
		LONG_TEXT: 230,
		SHORT_TEXT: 145,
		DEFAULT: 110,
		SMALL: 100
	};

	public static readonly DURATION_BUCKETS: Map<string, string> = new Map([
		['3M', '0-1Y'],
		['3m', '0-1Y'],
		['5M', '0-1Y'],
		['5m', '0-1Y'],
		['1Y', '1-3Y'],
		['1yr', '1-3Y'],
		['2Y', '1-3Y'],
		['2yr', '1-3Y'],
		['3Y', '3-5Y'],
		['3yr', '3-5Y'],
		['5Y', '5-7Y'],
		['5yr', '5-7Y'],
		['7Y', '7-10Y'],
		['7yr', '7-10Y'],
		['10Y', '10-15Y'],
		['10yr', '10-15Y'],
		['15Y', '15Y+'],
		['15yr', '15Y+'],
		['20Y', '15Y+'],
		['20yr', '15Y+'],
		['25Y', '15Y+'],
		['25yr', '15Y+'],
		['30Y', '15Y+'],
		['30yr', '15Y+'],
		['40Y', '15Y+'],
		['40yr', '15Y+'],
		['50Y', '15Y+'],
		['50yr', '15Y+']
	]);

	public static readonly KEY_RATE_CURRENCIES: Map<string, string> = new Map([
		['EUR', 'EUR'],
		['DEM', 'EUR'],
		['USD', 'USD'],
		['Tsy', 'USD'],
		['CHF', 'CHF'],
		['JPY', 'JPY'],
		['DKK', 'DKK'],
		['ILS', 'ILS'],
		['ILS TELBOR', 'ILS'],
		['NOK', 'NOK'],
		['SEK', 'SEK'],
		['PLN', 'PLN'],
		['GBP', 'GBP']
	]);

	public static readonly RATE_BUCKETS: Map<string, string> = new Map([
		['GBP', 'GBP Int Rates'],
		['USD', 'USD Int Rates'],
		['Tsy', 'USD Int Rates'],
		['JPY', 'JPY Int Rates'],
		['CHF', 'CHF Int Rates'],
		['DEM', 'EUR Int Rates'],
		['European Sovereign Spreads', 'Other'],
		['DKK', 'Other'],
		['SEK', 'Other'],
		['NOK', 'Other'],
		['PLN', 'Other'],
		['CZK', 'Other'],
		['ILS', 'Other'],
		['Other Rates', 'Other']
	]);

	public static readonly SPREAD_RISK: Map<string, string> = new Map([
		['IG schema', 'Investment Grade'],
		['IG Schema', 'Investment Grade'],
		['Investment Grade', 'Investment Grade'],
		['HY Schema', 'High Yield'],
		['High Yield', 'High Yield'],
		['Distressed Schema', 'Distressed'],
		['Distressed', 'Distressed'],
		['Swap Spreads', 'Swap Spreads'],
		['USD EM', 'USD EM'],
		['Non USD EM', 'Non USD EM'],
		['Other Spreads', 'Other Spreads']
	]);

	public static readonly FX_RISK: Map<string, string> = new Map([
		['AUD', 'AUD / '],
		['CAD', 'CAD / '],
		['CHF', 'CHF / '],
		['EUR', 'EUR / '],
		['GBP', 'GBP / '],
		['JPY', 'JPY / '],
		['USD', 'USD / '],
		['AED', 'Other / '],
		['ARS', 'Other / '],
		['BRL', 'Other / '],
		['CLP', 'Other / '],
		['CNH', 'Other / '],
		['CNY', 'Other / '],
		['COP', 'Other / '],
		['CZK', 'Other / '],
		['DKK', 'Other / '],
		['EGP', 'Other / '],
		['HKD', 'Other / '],
		['HUF', 'Other / '],
		['IDR', 'Other / '],
		['ILS', 'Other / '],
		['INR', 'Other / '],
		['KRW', 'Other / '],
		['KWD', 'Other / '],
		['MXN', 'Other / '],
		['MYR', 'Other / '],
		['NOK', 'Other / '],
		['NZD', 'Other / '],
		['PEN', 'Other / '],
		['PHP', 'Other / '],
		['PKR', 'Other / '],
		['PLN', 'Other / '],
		['QAR', 'Other / '],
		['RON', 'Other / '],
		['RUB', 'Other / '],
		['SAR', 'Other / '],
		['SEK', 'Other / '],
		['SGD', 'Other / '],
		['THB', 'Other / '],
		['TRY', 'Other / '],
		['TWD', 'Other / '],
		['ZAR', 'Other / ']
	]);

	public static readonly ALL_KEY_RATE_CURRENCIES = Array.from(new Set(DataServiceConstants.KEY_RATE_CURRENCIES.values()));
	public static readonly ALL_RATE_CURRENCIES = Array.from(new Set(DataServiceConstants.RATE_BUCKETS.keys()));
	public static readonly ORDERED_BUCKETS = Array.from(new Set(DataServiceConstants.DURATION_BUCKETS.values()));
	public static readonly ORDERED_RATE_BUCKETS = Array.from(new Set(DataServiceConstants.RATE_BUCKETS.values()));
	public static readonly ORDERED_SPREAD_RISK = Array.from(new Set(DataServiceConstants.SPREAD_RISK.values()));
}
